(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aligncart-exit-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('ac-exit-offer');
  if (!dialog || !dialog.showModal || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const key = 'aligncart-exit-offer-v2-' + dialog.dataset.offerKind;
  let seen = false;
  try { seen = sessionStorage.getItem(key) === '1'; } catch (_) {}
  let engaged = false;
  let deepest = window.scrollY;
  let previousY = window.scrollY;
  let active = true;
  let previousFocus;
  const storeSeen = () => {
    seen = true;
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
  };
  const show = () => {
    if (seen || !engaged || !active || document.visibilityState !== 'visible') return;
    if (document.querySelector('dialog[open], .menu-drawer-container[open], details-modal details[open], cart-drawer.active')) return;
    if (document.activeElement && document.activeElement.matches('input,textarea,select')) return;
    storeSeen();
    previousFocus = document.activeElement;
    dialog.showModal();
  };
  document.addEventListener('pointerdown', (event) => {
    if (!dialog.contains(event.target) && event.target.closest('main select, main button, main label')) engaged = true;
  }, {passive:true});
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    deepest = Math.max(deepest, y);
    if (y > 150) engaged = true;
    const mobile = window.matchMedia('(max-width: 749px), (pointer: coarse)').matches;
    if (mobile && y < previousY && y < 180 && deepest > Math.max(700, window.innerHeight * 1.2) && deepest - y > window.innerHeight * .65) show();
    previousY = y;
  }, {passive:true});
  document.addEventListener('mouseout', (event) => {
    if (window.matchMedia('(pointer: fine)').matches && event.relatedTarget === null && event.clientY <= 8) show();
  });
  dialog.querySelector('.ac-exit__close').addEventListener('click', () => dialog.close());
  dialog.querySelector('.ac-exit__dismiss').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { if (previousFocus && previousFocus.isConnected) previousFocus.focus({preventScroll:true}); });
  const returnLink = dialog.querySelector('[data-return-to-offer]');
  if (returnLink) returnLink.addEventListener('click', (event) => {
    event.preventDefault();
    dialog.close();
    const target = document.querySelector('quantity-breaks, variant-selects, form[action*=\"/cart/add\"]') || document.querySelector('main');
    if (target) target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
  });
  document.addEventListener('submit', (event) => { if (event.target.closest('form[action*=\"/cart/add\"]')) active = false; }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aligncart-gift-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const W = 1080, H = 1350;
  const wrap = (ctx, text, maxWidth) => {
    const words = text.split(/\s+/).filter(Boolean);
    const lines = [];
    let line = '';
    words.forEach((word) => {
      const test = line ? line + ' ' + word : word;
      if (ctx.measureText(test).width > maxWidth && line) { lines.push(line); line = word; } else { line = test; }
    });
    if (line) lines.push(line);
    return lines;
  };
  const roundRect = (ctx, x, y, w, h, r) => {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  };
  const setup = (scope) => scope.querySelectorAll('[data-ac-gift]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const canvas = root.querySelector('canvas');
    const ctx = canvas.getContext('2d');
    const field = (name) => root.querySelector('[data-f="' + name + '"]');
    const status = root.querySelector('.ac-gift__status');
    const count = root.querySelector('[data-count]');
    const shareButton = root.querySelector('[data-act="share"]');
    const isGrace = root.dataset.kind === 'grace';
    let image = null;
    let imageTried = false;
    const say = (message) => { status.textContent = message; clearTimeout(root._timer); root._timer = setTimeout(() => { status.textContent = ''; }, 3500); };
    const draw = () => {
      const to = (field('to').value || '').trim();
      const from = (field('from').value || '').trim();
      const message = (field('msg').value || '').trim();
      const verseField = field('verse');
      const verse = verseField && verseField.value ? verseField.value.split('|') : null;
      count.textContent = field('msg').value.length + ' / 140';
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = '#fffdf9';
      ctx.fillRect(0, 0, W, H);
      ctx.strokeStyle = '#6f2033';
      ctx.lineWidth = 8;
      ctx.strokeRect(36, 36, W - 72, H - 72);
      ctx.strokeStyle = '#e3d9dc';
      ctx.lineWidth = 2;
      ctx.strokeRect(58, 58, W - 116, H - 116);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = '#6f2033';
      ctx.font = '700 28px Arial, sans-serif';
      if ('letterSpacing' in ctx) ctx.letterSpacing = '6px';
      const eyebrow = isGrace ? (to ? 'FOR ' + to.toUpperCase() : 'A GIFT OF LIGHT') : (to ? 'FOR ' + to.toUpperCase() : 'SOMEONE IS WATCHING');
      ctx.fillText(eyebrow, W / 2, 128);
      if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
      const box = 600, bx = (W - box) / 2, by = 160;
      ctx.fillStyle = '#f4efeb';
      roundRect(ctx, bx, by, box, box, 24);
      ctx.fill();
      if (image) {
        const scale = Math.min(box / image.width, box / image.height);
        const iw = image.width * scale, ih = image.height * scale;
        ctx.save();
        roundRect(ctx, bx, by, box, box, 24);
        ctx.clip();
        ctx.drawImage(image, bx + (box - iw) / 2, by + (box - ih) / 2, iw, ih);
        ctx.restore();
      }
      ctx.fillStyle = '#292528';
      ctx.font = '400 62px Georgia, serif';
      ctx.fillText(isGrace ? 'A little light for you' : 'Don’t look now…', W / 2, 850);
      let y = 918;
      if (message) {
        ctx.font = 'italic 400 38px Georgia, serif';
        ctx.fillStyle = '#292528';
        wrap(ctx, message, 800).slice(0, 4).forEach((line) => { ctx.fillText(line, W / 2, y); y += 50; });
      }
      if (verse) {
        y += 16;
        ctx.font = 'italic 400 30px Georgia, serif';
        ctx.fillStyle = '#686168';
        wrap(ctx, '“' + verse[0] + '”', 820).slice(0, 4).forEach((line) => { ctx.fillText(line, W / 2, y); y += 40; });
        ctx.font = '700 26px Arial, sans-serif';
        ctx.fillStyle = '#6f2033';
        ctx.fillText(verse[1], W / 2, y + 6);
      }
      if (from) {
        ctx.font = '700 38px Georgia, serif';
        ctx.fillStyle = '#6f2033';
        ctx.fillText('— ' + from, W / 2, 1236);
      }
      ctx.font = '700 24px Arial, sans-serif';
      ctx.fillStyle = '#686168';
      if ('letterSpacing' in ctx) ctx.letterSpacing = '8px';
      ctx.fillText('ALIGNCART', W / 2, 1296);
      if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
    };
    const loadImage = () => {
      if (imageTried) return;
      imageTried = true;
      const source = root.dataset.image;
      if (!source) return;
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => { image = img; draw(); };
      img.onerror = () => { image = null; draw(); };
      img.src = source;
    };
    const toBlob = () => new Promise((resolve) => { try { canvas.toBlob((blob) => resolve(blob), 'image/png'); } catch (_) { resolve(null); } });
    let pending;
    root.querySelectorAll('input,textarea,select').forEach((el) => el.addEventListener('input', () => { clearTimeout(pending); pending = setTimeout(draw, 40); }));
    root.addEventListener('toggle', () => { if (root.open) { loadImage(); draw(); } });
    root.querySelector('[data-act="download"]').addEventListener('click', async () => {
      draw();
      const blob = await toBlob();
      if (!blob) { say('Could not create the card. Please try again.'); return; }
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'aligncart-gift-card.png';
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(link.href), 4000);
      say('Card saved.');
    });
    if (navigator.canShare && navigator.share) {
      try {
        const probe = new File([''], 'card.png', { type: 'image/png' });
        if (navigator.canShare({ files: [probe] })) shareButton.hidden = false;
      } catch (_) {}
    }
    shareButton.addEventListener('click', async () => {
      draw();
      const blob = await toBlob();
      if (!blob) { say('Could not create the card. Please try again.'); return; }
      try { await navigator.share({ files: [new File([blob], 'aligncart-gift-card.png', { type: 'image/png' })], title: 'A card for you' }); } catch (_) {}
    });
    draw();
  });
  const start = () => setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aligncart-glow-guide"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = (scope) => scope.querySelectorAll('[data-ac-guide]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const state = { size: '', power: root.dataset.powerGuess || '' };
    const result = root.querySelector('.ac-guide__result');
    const pick = root.querySelector('.ac-guide__pick');
    const note = root.querySelector('.ac-guide__note');
    const done = root.querySelector('.ac-guide__done');
    const sizeLabel = { '6': '6 ft (1.8 m)', '7': '7 ft (2.1 m)', '7plus': '7 ft (2.1 m)' };
    const powerLabel = { US: 'US plug', UK: 'UK plug', EU: 'EU plug', AU: 'AU plug', USB: 'USB power' };
    const mark = (attr, value) => root.querySelectorAll('[data-' + attr + ']').forEach((b) => b.setAttribute('aria-checked', String(b.dataset[attr] === value)));
    const render = () => {
      done.textContent = '';
      if (!state.size || !state.power) { result.hidden = true; return; }
      pick.innerHTML = 'We suggest the <strong>' + sizeLabel[state.size] + '</strong> set with <strong>' + powerLabel[state.power] + '</strong>.';
      note.textContent = state.size === '7plus' ? '7 ft is the largest set we offer. If your tree is taller, ask us before you order.' : '';
      result.hidden = false;
    };
    root.querySelectorAll('[data-size]').forEach((b) => b.addEventListener('click', () => { state.size = b.dataset.size; mark('size', state.size); render(); }));
    root.querySelectorAll('[data-power]').forEach((b) => b.addEventListener('click', () => { state.power = b.dataset.power; mark('power', state.power); render(); }));
    if (state.power) mark('power', state.power);
    /* The bundle selector treats the card of the last changed select as active, so the selects of the chosen card are updated last. */
    const orderedSelects = () => {
      const all = [...document.querySelectorAll('.quantity-break__variant-select')];
      const radio = document.querySelector('.quantity-breaks-container input[name="quantity"]:checked');
      const active = radio ? radio.nextElementSibling : null;
      const inActive = (select) => !!(active && active.contains(select));
      return all.filter((s) => !inActive(s)).concat(all.filter(inActive));
    };
    const pickOption = (select, test) => {
      const option = [...select.options].find((o) => test(o.value) || test(o.text.trim()));
      if (!option) return false;
      select.value = option.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    };
    root.querySelector('.ac-guide__apply').addEventListener('click', () => {
      let applied = 0;
      orderedSelects().forEach((select) => {
        if (select.name === 'options[Tree Size]') { if (pickOption(select, (v) => v.indexOf(state.size === '6' ? '6 ft' : '7 ft') === 0)) applied += 1; }
        if (select.name === 'options[Power]') { if (pickOption(select, (v) => v === state.power)) applied += 1; }
      });
      if (!applied) { done.textContent = 'Please choose your options in the selector above.'; return; }
      done.textContent = 'Selected above: ' + sizeLabel[state.size] + ' · ' + powerLabel[state.power] + '.';
      const target = document.querySelector('.quantity-breaks-container') || document.querySelector('quantity-breaks');
      if (target) target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    });
  });
  const start = () => setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aligncart-pair"] && !Shopify.designMode) return;
  try {
    (() => {
  function setup(scope) {
    scope.querySelectorAll('[data-ac-pair]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('[data-pair-form]');
      const selectors = [...root.querySelectorAll('[data-pair-variant]')];
      const button = root.querySelector('[data-pair-add]');
      const money = value => new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency:root.dataset.currency || 'USD',currencyDisplay:'code'}).format(value / 100);
      function update() {
        const original = selectors.reduce((total, select) => total + Number(select.selectedOptions[0]?.dataset.price || 0), 0);
        const rate = root.dataset.holiday === 'true' ? 0.15 : root.dataset.pet === 'true' ? 0.10 : 0;
        const discounted = rate > 0;
        const grouped = new Map();
        selectors.forEach(select => {const price=Number(select.selectedOptions[0]?.dataset.price || 0);grouped.set(select.value,(grouped.get(select.value)||0)+price)});
        const total = discounted ? [...grouped.values()].reduce((sum, price) => sum+price-Math.floor(price*rate),0) : original;
        root.querySelector('[data-pair-total]').textContent = money(total);
        root.querySelector('[data-pair-original]').hidden = !discounted;
        root.querySelector('[data-pair-original]').textContent = money(original);
        const saving=root.querySelector('[data-pair-saving]'); saving.hidden=!discounted; saving.textContent=saving.dataset.text.replace('__amount__',money(original-total));
        button.disabled = selectors.some(select => !select.selectedOptions[0] || select.selectedOptions[0].disabled);
        button.textContent = button.disabled ? button.dataset.unavailable : button.dataset.label;
      }
      selectors.forEach(select => select.addEventListener('change', update)); update();
      form.addEventListener('submit', async event => {
        event.preventDefault(); if (button.disabled) return;
        const error=root.querySelector('[data-pair-error]');error.textContent='';button.disabled=true;button.textContent=button.dataset.busy;
        const base=root.dataset.root.endsWith('/')?root.dataset.root:root.dataset.root+'/';
        try {
          const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:selectors.map(select=>({id:Number(select.value),quantity:1}))})});
          const data=await response.json();if(!response.ok)throw new Error(data.description || error.dataset.fallback);
          window.location.assign(base+'cart');
        } catch (failure) {error.textContent=failure.message || error.dataset.fallback;update();button.textContent=button.dataset.label;}
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>setup(document)); else setup(document);
  document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aligncart-pouchly-picker"] && !Shopify.designMode) return;
  try {
    (() => {
  const ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  const setup = (scope) => scope.querySelectorAll('[data-ac-picker]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const state = { pet: '', color: '', image: '', size: '' };
    const result = root.querySelector('.ac-picker__result');
    const photo = root.querySelector('.ac-picker__photo');
    const pick = root.querySelector('.ac-picker__pick');
    const note = root.querySelector('.ac-picker__note');
    const done = root.querySelector('.ac-picker__done');
    const available = [...root.querySelectorAll('.ac-picker__chips--size [data-size]')].map((b) => b.dataset.size);
    let suggested = '';
    const mark = (group, attr, value) => root.querySelectorAll(group + ' [data-' + attr + ']').forEach((b) => b.setAttribute('aria-checked', String(b.dataset[attr] === value)));
    const suggest = (usual) => {
      const index = ORDER.indexOf(usual);
      for (let i = Math.min(index + 1, ORDER.length - 1); i < ORDER.length; i += 1) { if (available.indexOf(ORDER[i]) > -1) return ORDER[i]; }
      return usual;
    };
    const render = () => {
      done.textContent = '';
      if (!state.color || !state.size) { result.hidden = true; return; }
      suggested = suggest(state.size);
      const who = state.pet === 'cat' ? 'your cat' : state.pet === 'dog' ? 'your small dog' : 'your little companion';
      pick.innerHTML = '<strong>' + state.color + '</strong> · size <strong>' + suggested + '</strong>';
      note.textContent = 'A roomy front pouch for supervised cuddle time with ' + who + '. Pouchly follows Asian sizing and can run 1–2 sizes smaller, so we suggest one size up from your usual ' + state.size + '. If you are between sizes, choose the larger one.';
      if (state.image) { photo.src = state.image; photo.hidden = false; } else { photo.hidden = true; }
      result.hidden = false;
    };
    root.querySelectorAll('[data-pet]').forEach((b) => b.addEventListener('click', () => { state.pet = b.dataset.pet; mark('.ac-picker__chips', 'pet', state.pet); render(); }));
    root.querySelectorAll('[data-color]').forEach((b) => b.addEventListener('click', () => { state.color = b.dataset.color; state.image = b.dataset.image || ''; mark('.ac-picker__swatches', 'color', state.color); render(); }));
    root.querySelectorAll('.ac-picker__chips--size [data-size]').forEach((b) => b.addEventListener('click', () => { state.size = b.dataset.size; mark('.ac-picker__chips--size', 'size', state.size); render(); }));
    /* The bundle selector treats the card of the last changed select as active, so the selects of the chosen card are updated last. */
    const orderedSelects = () => {
      const all = [...document.querySelectorAll('.quantity-break__variant-select')];
      const radio = document.querySelector('.quantity-breaks-container input[name="quantity"]:checked');
      const active = radio ? radio.nextElementSibling : null;
      const inActive = (select) => !!(active && active.contains(select));
      return all.filter((s) => !inActive(s)).concat(all.filter(inActive));
    };
    const pickOption = (select, value) => {
      const option = [...select.options].find((o) => o.value === value || o.text.trim() === value);
      if (!option) return false;
      select.value = option.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    };
    root.querySelector('.ac-picker__apply').addEventListener('click', () => {
      let applied = 0;
      orderedSelects().forEach((select) => {
        if (select.name === 'options[Color]' && pickOption(select, state.color)) applied += 1;
        if (select.name === 'options[Size]' && pickOption(select, suggested)) applied += 1;
      });
      if (!applied) { done.textContent = 'Please choose your options in the selector above.'; return; }
      done.textContent = 'Selected above: ' + state.color + ' · ' + suggested + '.';
      const target = document.querySelector('.quantity-breaks-container') || document.querySelector('quantity-breaks');
      if (target) target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    });
  });
  const start = () => setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aligncart-share"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = (scope) => scope.querySelectorAll('[data-ac-share]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const button = root.querySelector('.ac-share__btn');
    const status = root.querySelector('.ac-share__status');
    const whatsapp = root.querySelector('.ac-share__wa');
    const title = root.dataset.title;
    const url = root.dataset.url;
    const text = 'Look what I found: ' + title;
    const canShare = typeof navigator.share === 'function';
    if (!canShare) {
      whatsapp.hidden = false;
      whatsapp.href = 'https://wa.me/?text=' + encodeURIComponent(text + ' ' + url);
    }
    const note = (message) => {
      status.textContent = message;
      clearTimeout(root._timer);
      root._timer = setTimeout(() => { status.textContent = ''; }, 3500);
    };
    button.addEventListener('click', async () => {
      if (canShare) {
        try { await navigator.share({ title, text, url }); } catch (_) {}
        return;
      }
      try {
        await navigator.clipboard.writeText(url);
        note('Link copied. Paste it into any chat.');
      } catch (_) {
        window.prompt('Copy this link', url);
      }
    });
  });
  const start = () => setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["peepcreep-boosters"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(area, key) { try { return window[area].getItem(key); } catch (_) { return null; } },
    set(area, key, value) { try { window[area].setItem(key, value); } catch (_) {} }
  };

  const cutoff = () => {
    const el = document.querySelector('[data-ac-cutoff]');
    if (!el) return;
    const max = parseInt(el.dataset.maxDays, 10) || 0;
    if (max < 1) return;
    const now = new Date();
    const year = now.getFullYear();
    const halloween = new Date(year, 9, 31, 23, 59, 59);
    if (now > halloween) return;
    const today = new Date(year, now.getMonth(), now.getDate());
    const last = new Date(halloween.getFullYear(), halloween.getMonth(), halloween.getDate() - max);
    const label = last.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    el.textContent = '';
    const strong = document.createElement('strong');
    const rest = document.createElement('span');
    if (today <= last) {
      const left = Math.round((last - today) / 864e5);
      const timing = left === 0 ? ' That is today.' : left === 1 ? ' 1 day left.' : left <= 7 ? ' ' + left + ' days left.' : '';
      strong.textContent = 'Halloween timing: ';
      el.append(strong, document.createTextNode('order by ' + label + ' for an estimated arrival by October 31 (' + (el.dataset.country || 'your country') + ').' + timing + ' '));
      rest.textContent = 'Estimates, not guarantees.';
    } else {
      strong.textContent = 'Halloween is close. ';
      el.append(strong, document.createTextNode('Arrival by October 31 is now unlikely, but PeepCreep works any day of the year: birthdays, April Fools, roommates. '));
      rest.textContent = 'Delivery is estimated, not guaranteed.';
    }
    el.append(rest);
    el.hidden = false;
  };

  const secondFace = () => {
    const root = document.querySelector('[data-peepcreep]');
    if (!root || root.dataset.acSecond) return;
    const form = root.querySelector('form[action*="/cart/add"]');
    const select = root.querySelector('[data-variant]');
    const offers = root.querySelector('.pc-offers');
    const add = root.querySelector('[data-add]');
    if (!form || !select || !offers || !add) return;
    root.dataset.acSecond = 'true';
    const imageFor = (id) => {
      const choose = root.querySelector('.pc-design-grid [data-choose="' + id + '"]');
      const img = choose && choose.closest('article') ? choose.closest('article').querySelector('img') : null;
      return img ? (img.currentSrc || img.src) : '';
    };
    const faces = [...select.options].map((o) => ({ id: o.value, title: o.text.replace(/\s+—.*$/, '').trim(), ok: o.dataset.available !== 'false' }));
    let secondId = select.value;
    let lastFirst = select.value;
    let busy = false;

    const link = document.createElement('button');
    link.type = 'button';
    link.className = 'ac-second__link';
    link.textContent = 'Got a second window? Pick a different face for it →';
    const panel = document.createElement('div');
    panel.className = 'ac-second';
    panel.hidden = true;
    const title = document.createElement('p');
    title.className = 'ac-second__title';
    title.textContent = 'Two windows, two faces';
    const text = document.createElement('p');
    text.className = 'ac-second__text';
    const chips = document.createElement('div');
    chips.className = 'ac-second__chips';
    chips.setAttribute('role', 'radiogroup');
    chips.setAttribute('aria-label', 'Face for the second window');
    const price = document.createElement('p');
    price.className = 'ac-second__price';
    const error = document.createElement('p');
    error.className = 'ac-second__error';
    error.setAttribute('role', 'alert');
    panel.append(title, text, chips, price, error);
    offers.insertAdjacentElement('afterend', panel);
    offers.insertAdjacentElement('afterend', link);

    const faceName = (id) => (faces.find((f) => f.id === id) || { title: '' }).title;
    const renderChips = () => {
      chips.textContent = '';
      faces.forEach((face) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', String(face.id === secondId));
        button.disabled = !face.ok;
        const src = imageFor(face.id);
        if (src) { const img = document.createElement('img'); img.src = src; img.alt = ''; img.width = 44; img.height = 44; img.loading = 'lazy'; button.append(img); }
        const label = document.createElement('span');
        label.textContent = face.title;
        button.append(label);
        button.addEventListener('click', () => { secondId = face.id; error.textContent = ''; renderChips(); renderText(); });
        chips.append(button);
      });
    };
    const renderText = () => {
      text.textContent = '';
      const strong = document.createElement('strong');
      strong.textContent = faceName(select.value);
      text.append('Window one gets ', strong, '. Which face goes on window two?');
      const pair = offers.querySelector('b[data-pair]');
      const regular = offers.querySelector('s[data-pair-regular]');
      price.textContent = '';
      if (pair) {
        const total = document.createElement('span');
        total.textContent = 'Both faces: ' + pair.textContent;
        price.append(total);
        if (regular && regular.textContent) { const was = document.createElement('s'); was.textContent = regular.textContent; price.append(was); }
        const fine = document.createElement('small');
        fine.textContent = 'The pair discount applies automatically, even with different faces. The final total is shown in your cart.';
        price.append(fine);
      }
    };
    const sync = () => {
      const pairOn = (offers.querySelector('input[name="quantity"]:checked') || {}).value === '2';
      panel.hidden = !pairOn;
      link.hidden = pairOn;
      if (pairOn) { renderChips(); renderText(); }
    };
    link.addEventListener('click', () => {
      const pairInput = offers.querySelector('input[name="quantity"][value="2"]');
      if (pairInput) { pairInput.click(); }
      sync();
      panel.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
    });
    offers.addEventListener('change', sync);
    select.addEventListener('change', () => {
      if (secondId === lastFirst || !faces.some((f) => f.id === secondId)) secondId = select.value;
      lastFirst = select.value;
      sync();
    });
    const watch = new MutationObserver(() => { if (!panel.hidden) renderText(); });
    offers.querySelectorAll('b[data-pair],s[data-pair-regular]').forEach((node) => watch.observe(node, { childList: true, characterData: true, subtree: true }));

    form.addEventListener('submit', async (event) => {
      const picked = offers.querySelector('input[name="quantity"]:checked');
      if (!picked || picked.value !== '2' || !secondId || secondId === select.value) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      busy = true;
      error.textContent = '';
      const label = add.textContent;
      add.disabled = true;
      add.textContent = 'Adding both…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }, { id: Number(secondId), quantity: 1 }] }) });
        if (!response.ok) { const data = await response.json().catch(() => ({})); throw new Error(data.description || 'Could not add both faces. Please try again.'); }
        const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        window.location.assign(base + 'cart');
      } catch (failure) {
        error.textContent = failure.message || 'Could not add both faces. Please try again.';
        busy = false;
        add.disabled = false;
        add.textContent = label;
      }
    }, true);
    sync();
  };

  const peekOffer = () => {
    const peek = document.querySelector('[data-ac-peek]');
    if (!peek || peek.dataset.ready) return;
    peek.dataset.ready = 'true';
    if (store.get('sessionStorage', 'ac-peek') === '1' || store.get('localStorage', 'ac-peek-used') === '1') return;
    const code = peek.dataset.code;
    const face = peek.querySelector('.ac-peek__face');
    const card = peek.querySelector('.ac-peek__card');
    const apply = peek.querySelector('.ac-peek__apply');
    const status = peek.querySelector('.ac-peek__status');
    const close = () => { card.hidden = true; };
    face.addEventListener('click', () => { card.hidden = !card.hidden; });
    peek.querySelector('.ac-peek__close').addEventListener('click', () => { close(); face.focus({ preventScroll: true }); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !card.hidden) close(); });
    apply.addEventListener('click', async () => {
      apply.disabled = true;
      try {
        await fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
        store.set('localStorage', 'ac-peek-used', '1');
        apply.textContent = 'Applied';
        status.textContent = 'Done. Your 10% will show at checkout.';
        setTimeout(close, 3500);
      } catch (_) {
        apply.disabled = false;
        status.textContent = 'Could not apply it here. Enter ' + code + ' at checkout.';
      }
    });
    let pending = true;
    const reveal = (attempt) => {
      if (!pending || document.visibilityState !== 'visible') return;
      if (document.querySelector('dialog[open]')) {
        if (attempt < 6) setTimeout(() => reveal(attempt + 1), 8000);
        return;
      }
      pending = false;
      store.set('sessionStorage', 'ac-peek', '1');
      peek.hidden = false;
      setTimeout(() => peek.classList.add('is-in'), 30);
    };
    document.addEventListener('visibilitychange', () => { if (pending && document.visibilityState === 'visible') setTimeout(() => reveal(0), 1500); });
    setTimeout(() => reveal(0), 20000);
  };

  const start = () => { cutoff(); secondFace(); peekOffer(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
  } catch(e) { console.error(e); }
})();

})();
